import PropTypes from 'prop-types';
import React from 'react';

import { Box, Flex } from '../../grid';
import { icons } from './icons';
import { NavLink } from './styles';
import { P } from '../../typography/new';
import { Icon } from '../../icons';

const NavItem = ({ active, label, href, badge, ...rest }) => (
  <NavLink
    href={href}
    key={href}
    active={active}
    px="20px"
    py="16.5px"
    borderBottom="1px solid"
    borderColor="rgba(0, 0, 0, 0.1)"
    {...rest}
  >
    <Flex justifyContent="space-between">
      <Flex>
        <Box mr="16px">
          <Icon
            name={icons[label].name}
            fill={active ? 'primaryRed' : icons[label].fill}
            stroke={active ? 'primaryRed' : icons[label].stroke}
            width="24px"
            height="24px"
            strokeWidth="2px"
          />
        </Box>
        <P variant="standard-semi-bold">{label}</P>
      </Flex>
      <Icon name="chevronRight" fill={icons[label].fill} width="20px" height="20px" />
    </Flex>
  </NavLink>
);

NavItem.propTypes = {
  active: PropTypes.bool,
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  badge: PropTypes.number,
};

NavItem.defaultProps = {
  active: false,
  badge: undefined,
};

export { NavItem };
